import { useQuery } from '@apollo/client';
import { ME_QUERY } from '../graphql';

export function Profile() {
  const { data, loading, error } = useQuery<{ me: { id: string; username: string; karma: number; bio?: string | null } }>(ME_QUERY);
  if (loading) return <div className="card p-6 animate-pulse">loading…</div>;
  if (error) {
    return (
      <div className="card p-6 text-center">
        <p className="text-mute mb-3">You're not signed in.</p>
        <a href="/login" className="btn-primary">Sign in</a>
      </div>
    );
  }
  const me = data?.me;
  if (!me) return null;
  return (
    <section className="card p-6 animate-slide-up">
      <div className="flex items-center gap-4 mb-4">
        <div className="grid place-items-center h-14 w-14 rounded-full bg-gradient-to-br from-accent to-accent-deep text-white font-bold text-xl">
          {me.username.charAt(0).toUpperCase()}
        </div>
        <div>
          <h1 className="text-xl font-semibold">{me.username}</h1>
          <p className="text-sm text-mute">{me.karma} karma</p>
        </div>
      </div>
      {me.bio && <p className="text-mute-soft">{me.bio}</p>}
    </section>
  );
}
